import { Component, ChangeDetectionStrategy, ChangeDetectorRef, HostBinding } from '@angular/core';
import { FormBaseComponent } from '../../models/form-base-component';
import { FormButtonField } from './form-button.model';
import { FormFieldService } from '../../services/form-field.service';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Component({
  selector: 'gio-form-button',
  templateUrl: './form-button.component.html',
  styleUrls: ['./form-button.component.scss'],
  host: {
    '[class]': 'classNames'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormButtonComponent extends FormBaseComponent<FormButtonField> {
  @HostBinding('style')
  get myStyle() { return this.getHostStyles(); }

  active = false;
  formState: 'idle' | 'edit';

  constructor(
    private cd: ChangeDetectorRef,
    public _service: FormFieldService,
    sanitizer: DomSanitizer
  ) { super(cd, _service, sanitizer); }

  onComponentInit() {
    this.field.button.color = this.field.button.color ?? 'primary';
    this.field.button.layout = this.field.button.layout ?? 'raised';

    let buttonType = this.field.button?.type;
    if (buttonType?.inArray(['submit', 'cancel']) && this.field.activeWithFormState == null) {
      this.field.activeWithFormState = true;
    }
    if (this.field.disabled && typeof (this.field.disabled) == 'function') {
      this.subscribe = this.service.form.valueChanges.subscribe(value => {
        this.updateActiveStatus();
      })
    }

    this.subscribe = this.service.state.subscribe(formState => {
      this.formState = formState;
      this.updateActiveStatus();
    });

    this.updateActiveStatus();
  }


  updateActiveStatus() {
    this.active = true;

    if (this.field.disabled != null) {
      if (typeof (this.field.disabled) == 'boolean') {
        this.active = !this.field.disabled;
      } else if (typeof (this.field.disabled) == 'function') {
        this.active = !(this.field.disabled(this.service.form.value, this.service));
      }

    } else if (this.field.activeWithFormState) {
      this.active = this.formState == 'edit';
    }
    this.cd.detectChanges();

  }

  onComponentDestroy() { }

  buttonClick() {
    if (this.field.button) {
      if (this.field.button.click) {
        this.field.button.click(this.service);
      }

      if (this.field.button.type === 'cancel') {
        this.service.cancel$.next();
      }
      if (this.field.button.type === 'submit') {
        this.service.submit$.next(this.field.id);
      }

    }
  }

  getButtonClasses() {
    if (this.field.button.classes) {
      return this.field.button.classes.join(' ');
    }
    return '';
  }

}
